import { render, staticRenderFns } from "./DeliveryDuration.vue?vue&type=template&id=33b2d4a0&lang=pug&"
import script from "./DeliveryDuration.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDuration.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports